import { formatTime } from '../../utils';
import { cn } from '@/utils';
import React from 'react';

interface ResolutionStatsProps {
  avgTimeDelivered: number;
  avgTimeNotDelivered: number;
}

export const ResolutionStats: React.FC<ResolutionStatsProps> = ({
  avgTimeDelivered,
  avgTimeNotDelivered,
}) => {
  const deliveredTime = formatTime(avgTimeDelivered);
  const notDeliveredTime = formatTime(avgTimeNotDelivered);
  const isInefficient = avgTimeNotDelivered > avgTimeDelivered;

  return (
    <div className='grid grid-cols-2 gap-6 mt-6 border-t border-slate-50 pt-6'>
      <div className='flex flex-col items-center group transition-transform hover:-translate-y-1'>
        <span className='text-3xl font-black text-emerald-500 tabular-nums'>
          {deliveredTime.value}
          <span className='text-base ml-1 opacity-70'>
            {deliveredTime.unit}
          </span>
        </span>
        <span className='text-[10px] font-black text-slate-400 uppercase tracking-widest mt-1 text-center leading-tight'>
          Promedio de Entregados
        </span>
      </div>

      <div className='flex flex-col items-center border-l border-slate-100 group transition-transform hover:-translate-y-1'>
        <span
          className={cn(
            'text-3xl font-black tabular-nums',
            isInefficient ? 'text-rose-500' : 'text-slate-600'
          )}
        >
          {notDeliveredTime.value}
          <span className='text-base ml-1 opacity-70'>
            {notDeliveredTime.unit}
          </span>
        </span>
        <span className='text-[10px] font-black text-slate-400 uppercase tracking-widest mt-1 text-center leading-tight'>
          Promedio de No Entregados
        </span>
      </div>
    </div>
  );
};
